import React, { useEffect } from 'react';
import { Route, useHistory, useLocation } from 'react-router-dom';
import { RouteProps } from 'react-router';
import { Result, Row, Spin } from 'antd';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useProfile } from 'src/features/auth/auth.hooks';

interface RoleProps {
  roles?: string[];
}

const GuardedRoute = (props: RouteProps & RoleProps): React.JSX.Element => {
  const location = useLocation();
  const history = useHistory();
  const user = useProfile();
  const authIsPending = useSelector<RootState, boolean>(state => state.auth.manager.isPending);
  const { roles } = props;

  useEffect(() => {
    if (!authIsPending && !user) {
      history.push(`/login?redirectUri=${location.pathname}`);
    }
  }, [user, history, authIsPending, location.pathname]);

  if (authIsPending || !user) {
    return (
      <Row align={'middle'} justify={'center'} style={{ minHeight: '100vh' }}>
        <Spin size={'large'} />
      </Row>
    );
  }

  if (roles) {
    return roles.includes(user.role) ? (
      <Route {...props} />
    ) : (
      <Result status='404' title='404' subTitle='Извините, но запрашиваемая страница не найдена.' />
    );
  }

  return <Route {...props} />;
};

export default GuardedRoute;
